export const LeftNavigationInjects: any[] = [];
export const isShowApplications = () => true;
export const isShowFirst = () => false;
export const isShowAnalytic = () => true;
